import { z } from 'zod/v4'

export const baseStorageSchema = z.object({
  type: z.enum(['S3']).optional(),
  docType: z.enum(['yDoc']).describe('Type of the document, e.g., yDoc').optional(),
  filename: z.string(),
})
export type Storage = z.infer<typeof baseStorageSchema>

export const s3StorageSchema = baseStorageSchema.extend({
  type: z.literal('S3').optional(),
  versionId: z.string().describe('Version ID of the file in S3').optional(),
})

export const storageSchema = s3StorageSchema

export type S3Storage = z.infer<typeof s3StorageSchema>

export function isStorage(node?: unknown): node is Storage {
  return storageSchema.safeParse(node).success
}

export function isS3Storage(node?: unknown): node is S3Storage {
  return s3StorageSchema.safeParse(node).success
}

export const yDocStorageSchema = s3StorageSchema.extend({
  docType: z.literal('yDoc'),
})
export type YDocStorage = z.infer<typeof yDocStorageSchema>

export function isYDocStorage(node?: unknown): node is YDocStorage {
  return yDocStorageSchema.safeParse(node).success
}

export const storageUrlsSchema = z.object({
  expiresAtISODateTime: z.iso.datetime(),
  /** main Url for the resource */
  url: z.string(),
})

export type StorageUrls = z.infer<typeof storageUrlsSchema>

export const isStorageUrlsExpired = (storageUrls?: StorageUrls): boolean => {
  if (!storageUrls?.expiresAtISODateTime) {
    return false
  }
  return new Date(storageUrls.expiresAtISODateTime) < new Date()
}
